export const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <path
      d="M823.058,231.951a15,15,0,1,1,15-15,3.838,3.838,0,1,1-7.676,0,7.327,7.327,0,1,0-7.327,7.327q.262,0,.522-.018a12.919,12.919,0,0,0,7.673,5.254A15,15,0,0,1,823.058,231.951Z"
      transform="translate(-808.058 -201.951)"
      fill="var(--primaryColor)"
    />
  </svg>
);
